import Vue from 'vue'
import VueRouter from 'vue-router'
import Header from '@/layout/Header'
import Footer from '@/layout/Footer'

import Home from '@/pages/Home'
import Login from '@/pages/Login'
import CallbackLine from '@/pages/CallbackLine'
import Register from '@/pages/Register'
import Profile from '@/pages/user/Profile'
import Shop from '@/pages/user/Shop'

import Dashboard from '@/components/user/Dashboard'
import Manageshop from '@/components/user/Manageshops'
import Transfer from '@/components/user/Transfer'
import SettingProfile from '@/components/user/Setting'
import Transection from '@/components/user/shop/Transection'
import Setting from '@/components/user/shop/Setting'
import Views from '@/components/user/shop/Views'

Vue.use(VueRouter)

const routes = [
    { 
        path: '/',
        name: 'Home',
        components: {
            header: Header,
            default: Home,
            footer: Footer
        }
    },
    { 
        path: '/login',
        name: 'login',
        components: {
            header: Header,
            default: Login,
            footer: Footer
        }
    },
    { 
        path: '/logout',
        name: 'logout',
        beforeEnter: (to, from, next) => {
            localStorage.clear()
            next('/')
        }
    },
    { 
        path: '/CallbackLine',
        name: 'CallbackLine',
        components: {
            default: CallbackLine,
        }
    },
    { 
        path: '/register',
        name: 'register',
        components: {
            header: Header,
            default: Register,
            footer: Footer
        }
    },
    { 
        path: '/user',
        name: 'user',
        components: {
            header: Header,
            default: Profile,
            footer: Footer
        },
        children: [
            { path : '' , name: 'dashboard' , component : Dashboard },
            { 
                path : '/user/mangeshops' ,
                name:'mangeshops',
                component: Shop,
                children: [
                    { 
                        path : '',
                        name: 'mangeshops',
                        components: {
                            default: Manageshop
                        }
                    },
                    { 
                        path : '/user/mangeshops/:id/view',
                        name: 'view',
                        components: {
                            default: Views
                        }
                    },
                    { 
                        path : '/user/mangeshops/:id/transection',
                        name: 'transection',
                        components: {
                            default: Transection
                        }
                    },
                    { 
                        path : '/user/mangeshops/:id/setting',
                        name: 'setting',
                        components: {
                            default: Setting
                        }
                    }
                ]
            },
            { path : '/user/transfers' , name:'transfers', component : Transfer },
            { path : '/user/setting' , name:'SettingProfile', component : SettingProfile },
            
        ]
    },
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    mode: 'history',// cut to /#/login from url to /login ref : https://stackoverflow.com/questions/34623833/how-to-remove-hashbang-from-url
    routes // short for `routes: routes`
})

export default router